// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/workspace/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/workspace/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Sale Workspace · Vucar" })
  return <Page />
}
